const navigation = (() => {
    const _o = {
        html: document.querySelector('html'),
        header: document.querySelector("[data-header]"),
        menuTrigger: document.querySelector("[data-menu-trigger]"),
        menuWrapper: document.querySelector("[data-menu-wrapper]")
    };

    const init = () => {
        if(_o.menuTrigger) {
            _o.menuTrigger.addEventListener("click", (e) => onClickMenuTrigger(e, _o.menuTrigger));
            window.addEventListener("resize", () => close());
            window.addEventListener("scroll", () => onScroll());
        }
    };

    const onClickMenuTrigger = (e, trigger) => {
        _o.html.classList.toggle("modalOpened");
        trigger.classList.toggle("active");
        _o.menuWrapper.classList.toggle("active");

        if(!_o.header.classList.contains("active")){
            _o.header.classList.add("active")
        }
    };

    const close = () => {
        _o.html.classList.remove("modalOpened");
        _o.menuTrigger.classList.remove("active");
        _o.menuWrapper.classList.remove("active");
    };

    const onScroll = () => {
      if(window.scrollY > 10) {
          _o.header.classList.add("active");
      } else {
          _o.header.classList.remove("active");
      }
    };

    return {
        init: init
    };
})();

export {navigation};
